module.exports = __webpack_public_path__ + "img/t2.255de642.jpg";